import React, { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";

function EventCard({ data, type}) {
  const { user, token } = useOutletContext();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [applied, setApplied] = useState(data.applied);


  // Extract month, day, year from event_date
  const dateObj = new Date(data.event_date);
  const month = dateObj.toLocaleString("en-US", { month: "short" }).toUpperCase();
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();

  // Build image URL safely
  const imagePath = data.event_image.startsWith("/")
    ? data.event_image
    : `/uploads/event_images/${data.event_image}`;

  // Handle apply confirmation
  const handleApply = () => {
    setShowApplyModal(false);
    alert(`You have applied for ${data.event_name}!`);
  };


  const handleApplyClick = () => {
    fetch('/api/apply-event', {
        method:'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({event_id: data.id})
    }).then((response) => response.json())
    .then((data) => {
      setShowApplyModal(false)
        setApplied(true);
        setStatus(true);
       
    }).catch((error) => {
        
    })
  };

  const downloadEventApplyExcel = async (eventId) => {
  try {

    const response = await axios.post(
      "/api/export-event-apply",
      
      { event_id: eventId },

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob" // Important!
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `event_apply_${eventId}.xlsx`);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
};


if (type === "event") {

  

  return (
    <>
      {/* Event Card */}
      <div className="col-lg-4 col-md-6 pe-2 ps-2">
        <div className="card p-3 bg-white w-100 hover-card border-0 shadow-xss rounded-xxl mb-3 overflow-hidden">
          {/* Event Image */}
          <div
            className="card-image w-100"
            style={{ cursor: "pointer" }}
            onClick={() => setShowInfoModal(true)}
          >
            <img
              src={imagePath}
              alt={data.event_name}
              className="w-100 rounded-3 object-fit-cover"
              height={188}
            />
          </div>

          {/* Event Date + Info */}
          <div
            className="card-body d-flex ps-0 pe-0 pb-0"
            style={{ cursor: "pointer" }}
            onClick={() => setShowInfoModal(true)}
          >
            <div className="bg-greylight me-3 p-3 border-light-md rounded-xxl theme-dark-bg">
              <h4 className="fw-700 font-lg ls-3 text-grey-900 mb-0 text-center">
                <span className="ls-3 d-block font-xsss text-grey-500 fw-500">
                  {month}
                </span>
                {day}
                <span className="ls-3 d-block font-xsss text-grey-500 fw-500">
                  {year}
                </span>
              </h4>
            </div>

            <h2 className="fw-700 lh-3 font-xss">
              {data.event_name}
              <span className="d-flex flex-column font-xssss fw-500 mt-2 lh-3 text-grey-500">
                <span className="d-flex">

                <i className="ti-location-pin me-1" /> {data.event_venue} <br />
                </span>
                <span className="d-flex">

                <i className="ti-time  me-1" /> {data.event_time}
                </span>
              </span>
            </h2>
          </div>

          {/* Button */}
          
          <div className="card-body p-0">
            {
              (new Date(data.event_date) < new Date() || new Date(`${data.event_date} ${data.event_time}`) < new Date()) ? null :
              applied ? <button className="w-100 btn bg-current text-white my-2" disabled>Applied</button> :
              <button
              className="w-100 btn bg-current text-white my-2"
              onClick={() => setShowApplyModal(true)}
              >
              Apply Now
            </button>
            }
          </div>
        </div>
      </div>

      {/* Info Modal */}
      {showInfoModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
          onClick={() => setShowInfoModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-scrollable"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{data.event_name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowInfoModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <img
                  src={imagePath}
                  alt={data.event_name}
                  className="w-100 rounded mb-3"
                />
                <p><strong>Date:</strong> {data.event_date}</p>
                <p><strong>Time:</strong> {data.event_time}</p>
                <p><strong>Venue:</strong> {data.event_venue}</p>
                <p><strong>Description:</strong> {data.event_description}</p>
              </div>
              <div className="modal-footer">
                { (new Date(data.event_date) < new Date() || new Date(`${data.event_date} ${data.event_time}`) < new Date()) ? null :
              applied ? <button className="w-100 btn bg-current text-white my-2" disabled>Applied</button> : 
                <div>

                <button
                className="btn btn-danger"
                onClick={() => setShowInfoModal(false)}
                >
                  Close
                </button>
                <button
                className=" btn bg-current text-white my-2 ms-2"
                onClick={() => {
                  setShowInfoModal(false);
                  setShowApplyModal(true);
                }}
                >
                  Apply Now
                </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Apply Confirmation Modal */}
      {showApplyModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
          onClick={() => setShowApplyModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content text-center p-3">
              <div className="modal-header border-0">
                <h5 className="modal-title w-100">Confirm Application</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowApplyModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to apply for <strong>{data.event_name}</strong>?</p>
              </div>
              <div className="modal-footer border-0 d-flex justify-content-center">
                <button
                  className="btn btn-danger"
                  onClick={() => setShowApplyModal(false)}
                >
                  No
                </button>
                <button
                  className=" btn bg-current text-white my-2"
                  onClick={handleApplyClick}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
if (type==="my-event") {
   return (
    <>
      {/* Event Card */}
      <div className="col-lg-4 col-md-6 pe-2 ps-2">
        <div className="card p-3 bg-white w-100 hover-card border-0 shadow-xss rounded-xxl mb-3 overflow-hidden">
          {/* Event Image */}
          <div
            className="card-image w-100"
            style={{ cursor: "pointer" }}
            onClick={() => setShowInfoModal(true)}
          >
            <img
              src={imagePath}
              alt={data.event_name}
              className="w-100 rounded-3 object-fit-cover"
              height={188}
            />
          </div>

          {/* Event Date + Info */}
          <div
            className="card-body d-flex ps-0 pe-0 pb-0"
            style={{ cursor: "pointer" }}
            onClick={() => setShowInfoModal(true)}
          >
            <div className="bg-greylight me-3 p-3 border-light-md rounded-xxl theme-dark-bg">
              <h4 className="fw-700 font-lg ls-3 text-grey-900 mb-0 text-center">
                <span className="ls-3 d-block font-xsss text-grey-500 fw-500">
                  {month}
                </span>
                {day}
                <span className="ls-3 d-block font-xsss text-grey-500 fw-500">
                  {year}
                </span>
              </h4>
            </div>

            <h2 className="fw-700 lh-3 font-xss">
              {data.event_name}
              <span className="d-flex font-xssss fw-500 mt-2 lh-3 text-grey-500">
                <i className="ti-location-pin me-1" /> {data.event_venue}
              </span>
            </h2>
          </div>

          {/* Button */}
          <div className="card-body p-0">
            
             
              <button
              className="w-100 btn bg-current text-white my-2"
              onClick={() => downloadEventApplyExcel(data.id)}
              >
              Download Application
            </button>
            
          </div>
        </div>
      </div>

   
    </>
  );
  
}
if(type==="mini") {
    return (
      <>

        <div className="card-body d-flex pt-0 ps-4 pe-4 pb-3 overflow-hidden ">
          <div className="bg-success me-2 p-3 rounded-xxl">
          <Link to={`/events`}>
            <h4 className="fw-700 font-lg ls-3 lh-1 text-white mb-0 text-center">
              <span className="ls-1 d-block font-xsss text-white fw-600">{month}</span>{day}
              <span className="ls-3 d-block font-xsss text-white fw-600">{year}</span>
              </h4>
              </Link>
            </div>
          <Link to={`/events`}>
              <h4 className="fw-700 text-grey-900 font-xssss mt-2">{data.event_name} <span className="d-block font-xsssss fw-500 mt-1 lh-4 text-grey-500">{data.event_venue} <br /> {data.event_time}</span> </h4>
              </Link>
            </div>
            
</>

    );
}
}

export default EventCard;